export default __webpack_public_path__ + "static/media/purples-logo-2.b3914adc.png";